// TODO: remove properties from widget (type, options, dataSource, renderComponent)
<template lang="pug">
.card( :class="{'loading': loading}" :style='getChartHeightStyle')
  .chart-header.no-drag
    .date-row(v-if='widget.dateRangeFilter.active')
      span.section.left
        span.dateText {{ getDateText }}
      span.section.right
        span(
          v-on:click='setDate1Month'
          title='Date Interval'
          :class="last1MonthClasses"
        ) 1 - Month
        span.dateSelector-v-divider
        span(
          v-on:click='setDate3Months'
          title='Date Interval'
          :class="last3MonthsClasses"
         ) 3 - Months
        span.dateSelector-v-divider
        span(
          v-on:click='handleDate'
          title='Date Interval'
          :class="customIntervalClasses"
      ) Custom
    .header-row(v-if='showChartHeaderRow && showChart && !showInChartLegend')
      span.section.left
        span.back-action(v-if='showBack')
          a.fas.back-button.chart-back(href='#' @click='goBack', :title = 'showTitleOnBack' ) {{drillDownFilterText}}
        span.chartHeaderText(v-if='!showBack && chartHeaderTitle') {{chartHeaderTitle}}
      span.section.right(v-if='showChartHeaderRow')
        span.chartHeaderText(v-if='this.widget.dateRangeFilter.active') {{chartHeaderLabel}}
  .card-header.card-chart(:data-background-color='backgroundColor', :class="{ 'card-chart-tall': !showLegend, 'noData': !showChart} ", :style='customSettings.containterStyle')
    .empty(v-if='!showChart')
      h3.text-center
        //-br
        br
        i(:class = 'getNoDataIcon')
        br
        p.noData.bold No Results Found
        p.noData.light Try changing the date range or filters
    .ct-chart(v-else v-for='(chartCt, i) in visibleSeries'
              :id='chartId(chartCt, i)'
              :widgetId= 'widgetId(chartCt, i)'
              :class="{ 'hidden': !showChart }"
    )
    .inChartLegend(v-if='showInChartLegend && showChart')
      div.inChartLegendHead(v-if='!loading')
        span.section.left
          span.back-action(v-if='showBack')
            a.fas.back-button.chart-back(href='#' @click='goBack', :title = 'showTitleOnBack' ) {{drillDownFilterText}}
          span.chartHeaderText(v-if='!showBack && chartHeaderTitle') {{chartHeaderTitle}}
        span.section.right(v-if='showChartHeaderRow')
          span.chartHeaderText(v-if='this.widget.dateRangeFilter.active') {{chartHeaderLabel}}
      dl.legend
        dt.item.ct-interaction-on(:dataLabel="label" v-for='(label, y) in chartData && chartData.labels', :class="{ selected: selectedIndex === y }")
          span.swatch.events-off(:class=' `color-${colorStep(y, label, 0, 1)}` ')
          a.key.events-off {{ label }}
          component.value.events-off(:is='chartComponent.components.labelValue' v-if='chartComponent.components.labelValue' :currency='$parent.$parent.currency' :value='dataPointfromChart(chartData, y)')
          a.value.events-off(v-else :dataLabel="label" :dataValue='dataPointfromChart(chartData, y)') {{ thousandsFormat(dataPointfromChart(chartData, y), $parent.$parent.currency) }} 
  .card-content(v-if='showLegend && isDrilledDown')
    h4.title(v-if='!hasTitleSlot && title') {{ title }}
    slot(name='title')
    p.category
      slot(name='subTitle')

  .card-footer(v-if='showChart' :style='!showInChartLegend ? "" : "border-color: white"')
  .legend-small(v-if='showSmallLegend')
    .legend
      .item.no-border(v-for='(series, y) in getSmallLegendData && getSmallLegendData')
        span.swatch(:class= "{'line': series.type === 'Line'}", :style='{"background-color": series.color}')
        a.key {{ series.name }}
    .stats(v-if='showLegend')
      slot(name='footer')
        dl.legend
          dt.item(v-for='(label, y) in chartData && chartData.labels' v-if='y < 5', :class='{ selected: selectedIndex === y }')
            span.swatch(:class=' `color-${colorStep(y, label, 0, 1)}` ')
            a.key {{ label }}
            component.value(:is='chartComponent.components.labelValue' v-if='chartComponent.components.labelValue' :currency='$parent.currency' :value='dataPoint(chartData, y)')
            a.value(v-else) {{ dataPoint(chartData, y) }}

</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Chart widget
 * @module components/mdChartWidget
 *
 */

// import sample from '@/components/_modules/Dashboard/templates/demo.json'
import Vue from 'vue'
import { RenderComponent } from '@/core/charts/RenderComponent'
import { initScrollbar } from '@/components/_modules/Dashboard/helpers/scrollbarHelper.js'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { EventBus } from '@/event-bus'
import throttle from 'lodash/throttle'
import formatter from '@/core/charts/helper/formatter'
import user from '@/core/user'

export default {
  name: 'md-chart-widget',

  props: {
    id         : {
      type     : String,
      required : true
    },

    title      : String,
    type       : { // Line | Pie | Bar | Area
      type     : String,
      default  : 'Line',
      validator: val => {
        return ['Line', 'Pie', 'Bar', 'Area'].indexOf(val) >= 0
      }
    },

    widget: Object,

    backgroundColor: {
      type    : String,
      default : 'none'
    },

    options   : {
      type    : Object,
      default : () => {
        return {}
      }
    },

    data      : {
      type    : Object,
      default : () => {
        return {
          labels: [],
          series: []
        }
      }
    },

    dataSource      : String,

    animation : {
      type    : Boolean,
      default : true
    }

  },

  computed: {
    hasTitleSlot() {
      return !!this.$slots['title']
    },
    visibleSeries() {
      if (this.chartType === 'Pie') return [this.chartData.series]
      if (this.chartData.series) return this.chartData.series
      else return null
    },
    hasSmallLegend() {
      return this.customSettings.hasSmallLegend
    },
    getBackText() {
      return this.customSettings.backText || 'Back'
    },
    getSmallLegendData() {
      if (this.chartData.series.length === 0 || !this.showSmallLegend || this.chartData.series[0] === null) return
      else {
        let series = []
        this.chartData.series.forEach(ser => {
          let type = ser.type
          ser.data.forEach(dt => {
            series.push({name: dt.name, type: type, color: dt.color})
          })
        })
        return series
      }
    },
    showTitleOnBack() {
      if (this.drillDownFilterValue !== this.drillDownFilterText) return this.drillDownFilterValue
      return null
    },
    showChart() {
      if (!this.chartData.series[0] && this.showEmpty) return false
      else return true
    },
    getChartHeightStyle() {
      if (!this.loading) return ''
      let h = this.widget.h * 45
      if (this.widget.h === this.heights.MAX_ROWS) h += 45
      return 'height: ' + h + 'px;'
    },
    getDateText() {
      let startD = global.moment(this.widget._dateFilter[0]).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat)
      let endD = global.moment(this.widget._dateFilter[1]).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat)
      return ('Showing ' + startD + ' to ' + endD)
    },
    getNoDataIcon() {
      if (this.chartType === 'Pie') return 'fal fa-chart-pie'
      else return 'fal fa-chart-bar'
    },

    last1MonthClasses() {
      return [
        'dateSelectorTX',

        (this.widget &&
          ((this.widget.dateRangeFilter.dateRange === 'Last1Month') || (this.widget.dateRangeFilter.dateRange === 'last1Month'))
        ) ? 'active' : ''
      ]
    },
    last3MonthsClasses() {
      return [
        'dateSelectorTX',

        (this.widget &&
          ((this.widget.dateRangeFilter.dateRange === 'Last3Months') || (this.widget.dateRangeFilter.dateRange === 'last3Months'))
        ) ? 'active' : ''
      ]
    },
    customIntervalClasses() {
      return [
        'dateSelectorTX',

        (this.widget &&
          (this.widget.dateRangeFilter.dateRange !== 'Last1Month') &&
          (this.widget.dateRangeFilter.dateRange !== 'Last3Months') &&
          (this.widget.dateRangeFilter.dateRange !== 'last1Month') &&
          (this.widget.dateRangeFilter.dateRange !== 'last3Months')
        ) ? 'active' : ''
      ]
    }
  },

  data() {
    return {
      chartId: (chart, i) => chart && chart.data ? `${this.id}-${chart.type}-${i}` : this.id,
      widgetId: (chart, i) => this.id,
      chartData: this.data,
      rawData: [],
      chartType: this.type,
      loading: false,
      showBack: false,
      showChartHeaderRow: false,
      chartHeaderTitle: null,
      showEmpty: false,
      showLegend: this.showLegend,
      showSmallLegend: this.showSmallLegend,
      showInChartLegend: this.showInChartLegend,
      drillDownFilterText: this.drillDownFilterText,
      selectedIndex: null,
      customSettings: this.customSettings,
      tooltipStyle: { null: true },
      tooltipData: [],
      isDrilledDown: false,
      drilldownValue: null,
      needsRefresh: false,
      companySettings: {},
      seq: 0,
      seq2: 0,
      durations: 500,
      durations2: 500,
      delays: 80,
      delays2: 80,
      maxMultiplier: 1.2,
      heights: { MIN_ROWS: 8, MAX_ROWS: 8, NA_ROWS: 5, EX_MAX_ROWS: 20 },

      dataPoint: (data, y) => {
        if (this.chartComponent && this.chartComponent.chartInfo && this.chartComponent.chartInfo.length) {
          return this.chartInfo[y]
        }
        return data.series[0].data &&
          data.series[0].data[y] ||
          data.series[0][y]
      },

      dataPointfromChart: (data, y) => {
        if (this.chartComponent && data.series && data.series.length) {
          if (this.chartComponent.chartType === 'Pie' && data.labelData.length) {
            return data.labelData[y]
          }
          return data.series[0][y] || data.series[y]
        }
        return data.series[0].data &&
               data.series[0].data[y] ||
               data.series[0][y]
      },

      thousandsFormat(val, currency) {
        return formatter.thousandsFormatter(val) + ' ' + currency
      }
    }
  },

  created() {
    this.companySettings = user.getCompanySettings()
    this.chartComponent = this.initRenderComponent()
    this.showEmpty = false

    this.$on('childRedraw', () => {
      this.needsRefresh = true
    })
    this.$on('redraw', () => {
      this.init(this.drawChart)
    })
    this.$on('scrollIntoView', this.load)
  },

  updated() {
    if (this.needsRefresh) {
      this.$nextTick(() => {
        this.init(this.drawChart)
      })
      this.needsRefresh = false
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    initRenderComponent() {
      let chart = {}

      if (this.widget.chartComponent) {
        chart = new RenderComponent(this.widget.chartComponent)
        this.chartType = chart.chartType
        this.showLegend = chart.showLegend
        this.showSmallLegend = chart.showSmallLegend
        this.showInChartLegend = chart.showInChartLegend
        this._options = chart.chartOpts || this.options
        if (this._options.customSettings.chartGroupValue === 'Program') {
          this._options.customSettings.chartGroupValue = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program'
        }
        this.customSettings = this._options.customSettings
      }

      return chart
    },

    isIE() {
      var ua = window.navigator.userAgent
      var msie = ua.indexOf('MSIE ')
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        return true
      }
      return false
    },

    showEmptyChart() {
      this.showEmpty = true
      this.loading = false
      this.chartData.series = [null]
    },

    resetState() {
      this.showEmpty = true
      this.loading = false
      this.widthPixelBase = this.$el.clientWidth / this.widthId
      this.drilldownValue = null
      this.drillDownFilterText = null
      this.selectedIndex = null
      this.isDrilledDown = false
      this.showBack = false
      this.originalData = utils.copy(this.chartData)
      this.originalInfo = utils.copy(this.chartInfo)
      if (this.customSettings.hasDrillDown) this.chartComponent.drillDownReturn.call(this, this)
    },

    load() {
      this.loading = true
      if (this.dataSource) {
        this.showEmpty = false
        this.api.get(this.dataSource).then(r => {
          this.widget.reqDraw = false
          this.widget.isDrawn = true
          this.rawData = r.data.ChartData || []
          this.chartData = r.data.ChartData.length ? this.chartComponent.chartData(this.widget, r.data.ChartData) : { series: [] }
          this.chartInfo = r.data.ChartData.length ? this.chartComponent.chartInfo(this.widget, r.data.ChartData) : []
          this.resetState()
          this.$nextTick(() => {
            if (!r.data.ChartData.length) this.reqHeightAdjust('NA')
            else {
              if (this.widget.h !== this.heights.MAX_ROWS) this.reqHeightAdjust('OK')
              this.init(this.drawChart)
            }
          })
        }).catch(e => {
          this.showEmptyChart()
        })
      } else {
        this.showEmptyChart()
      }
    },

    reqHeightAdjust(state) {
      this.$nextTick(() => {
        EventBus.$emit('updateWidgetHeight', {
          wId: this.widget.id,
          height: 1,
          state: state,
          alt: -1
        })
      })
    },

    drawChart: function (chart, type) {
      switch (type) {
        case 'Line':
          this.animation && this.startAnimationForLineChart(chart)
          break
        case 'Bar':
          this.animation && this.startAnimationForBarChart(chart)
          break
        case 'Pie':
          this.animation && this.startAnimationForPieChart(chart)
          break
      }
      chart.on('created', (chart) => {
        if (this.showChart) {
          this.loading = false
          this.drawChartLines(chart)
          var ctChart = this.$el.querySelector('.ct-chart')
          if (this.chartComponent.chartType !== 'Pie') {
            initScrollbar(this, '.card-chart')
          } else {
            this.$el.querySelector('.ct-chart').classList.add('card-pie-chart')
            this.$el.querySelector('.ct-interaction-on').addEventListener('mouseover', throttle(this.showTooltip, 300))
            if (chart.options.customSettings.hasDrillDown === true) {
              this.$el.querySelector('.inChartLegend .legend').addEventListener('click', this.drillDown)
            }
          }
          this.$el.querySelector('.card-chart').addEventListener('mouseover', throttle(this.showTooltip, 300))
          ctChart.classList.add('events-on')
          let element = this.$el.querySelector("[widgetId='" + this.id + "']")
          if (element && chart.options.customSettings.hasDrillDown === true) element.addEventListener('click', this.drillDown)
        }
        this.widget.reqDraw = false
        this.widget.isDrawn = true
      })
    },

    drawChartLines(chart) {
      if (chart.options.targetLine) {
        this.drawVLines(chart, chart.options.targetLine)
      }
      if (chart.options.vLines) {
        Array.prototype.forEach.call(chart.options.vLines, (line) => {
          this.drawVLines(chart, line)
        })
      }
    },

    drawVLines(chart, line) {
      const tline = chart.chartRect.x1 + (chart.chartRect.width() * (line.value + Math.abs(chart.bounds.min))) / (chart.bounds.range)
      chart.svg
        .elem('line', {
          x1: tline,
          x2: tline,
          y1: chart.chartRect.y1,
          y2: chart.chartRect.y2,
          stroke: line.color
        }, line.class)
    },

    init(callback) {
      let idSelector = `#${this.id}`
      let type = this.chartType
      let showGr = false
      // Apply area to area chart
      if (type === 'Area') {
        type = 'Line'
        this.options.showArea = true
      }
      if (type !== 'Pie') {
        // apply basic defaults
        this.tooltipData = []
        this.options.showGridBackground = true
        this.options.chartPadding = { top: 15, right: 10, bottom: 0, left: 0 }
        this.options.axisY = {
          ...this.options.axisY,
          labelOffset: {
            x: 0,
            y: 5
          }
        }
      }
      if (!this.chartData.series[0] && this.ps) this.ps.destroy()
      this.fullTooltipData = this.chartData.tooltipData || null
      // Draw chart for each series of different type

      this.chartData.series.forEach((series, i) => {
        const id   = `#${this.chartId(series, i)}`
        const chdt = utils.copy(this.chartData)
        const data = {
          labels   : i === 0 ? chdt.labels : null,
          series   : series.data,
          stackBars: series.stackBars || false,
          maxValue : series.maxValue,
          minValue : series.minValue,
          barSpace : series.barSpace,
          minHeight : series.minHeight,
          labelData : series.labelData || this.chartData.labelData || null

        }
        // Create alias and update chart options
        const { _options : op } = this
        if (type !== 'Pie') {
          showGr = i === 0
          op.axisY.showGrid = showGr
          op.axisY.showLabel = showGr
          op.vLines = series.vLines || null
          op.stackBars = data.stackBars

          if (op.customSettings.dynamicWidth) op.width = this.calculateWidth(data)
          if (op.customSettings.dynamicHeight) op.height = this.calculateHeight(data)
          if (op.customSettings.recalculateGridMax) {
            let newRange = this.calculateGridRange(data.maxValue || chdt.maxValue || 0, data.minValue || chdt.minValue || 0)
            op.high = newRange.high
            op.low = newRange.low
          }
        } else {
          if (op.customSettings.isGaugeChart) op.total = chdt.total * 2
          op.showLabel = false
        }
        this.showChartHeaderRow = op.customSettings.showTotal || false
        if (this.showChartHeaderRow) this.chartHeaderLabel = op.customSettings.showTotalValue || 'Total'
        this.chartHeaderTitle = this.getchartHeaderTitle(op.customSettings.chartGroupValue)
        // Generate Chart
        const chart = this.$Chartist[series.type || type](series.data ? id : idSelector,
                                                          series.data ? data : chdt,
                                                          op)
        callback(chart, series.type || type)
      })
    },

    getchartHeaderTitle: function (input) {
      if (!input) return null
      else if (input.startsWith('FromFilter')) {
        let filterName = input.split(':')[1]
        let variable = this.widget.variables.filter(function(s) { if (s.name === filterName) return s.value[0] })
        let varDef = this.widget.variableDefinitions.filter(function(vd) { if (vd.name === filterName) return vd })[0].items.filter(function(va) { if (va.key === variable[0].value[0]) return va.label })
        return varDef[0].label
      }
      return input
    },

    calculateWidth: function (dataIn) {
      let barSpace  = 100
      let cardWidh = this.$el.clientWidth
      let barCount = dataIn.labels ? dataIn.labels.length : dataIn.series[0].value.length
      let width = barSpace * barCount < cardWidh ? cardWidh : barSpace * barCount
      return width + 'px'
    },

    calculateGridRange: function (max, min) {
      const result = { low: 0, high: 0 }
      if (max === 0 && min === 0) max = 100
      result.high = max <= 0 ? (20 / 100 * min * -1) : max * 1.4
      result.low = min >= 0 ? (10 / 100 * max * -1) : min * 1.4
      return result
    },

    calculateHeight: function (dataIn) {
      const barSpace  = dataIn.barSpace || 40
      const minHeight = dataIn.minHeight || 65
      const padding = 20
      let barCount = dataIn.labels ? dataIn.labels.length : dataIn.series[0].value.length
      let height = barSpace * (barCount) + padding
      return (height > minHeight ? height : minHeight) + padding + 'px'
    },

    startAnimationForLineChart(chart) {
      chart.on('draw', (data) => {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 0,
              dur: this.durations,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: this.$Chartist.Svg.Easing.easeOutQuint
            }
          })
        } else if (data.type === 'point') {
          this.seq++
          data.element.animate({
            opacity: {
              begin: 0,
              dur: this.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          })
        }

        if (data.type === 'line') {
          let lineColor = data.series.color ? data.series.color : null
          if (lineColor) {
            data.element.attr({
              style: `stroke: ${lineColor}; stroke-width: 1px`
            })
          }
        }
      })
      this.seq = 0
    },

    startAnimationForBarChart(chart) {
      chart.on('draw', (data) => {
        if (data.type === 'label' && data.axis.units.pos === 'y') {
          if (data.element._node.children && this.chartComponent.components.axisY) {
            data.element._node.children[0].innerHTML = '<span></span>'
            new Vue({
              render: h => h(this.chartComponent.components.axisY, {
                props: {
                  value: data.text
                }
              })
            }).$mount(data.element._node.children[0].children[0])
          }
        }

        if (data.type === 'bar') {
          const isVertical = chart.options.horizontalBars || false
          let customizedChart = data.series.color
          let label = customizedChart ? '' : this.chartData.labels[data.index].replace(/ /g, '')
          let barWidth =  customizedChart ? data.series.width : data.series.length > 6 ? '30px' : '12%'
          let barColor = customizedChart ? data.series.color : null
          this.seq2++
          if (data.series.xModifier) {
            let x1 = data.element._node.x1.baseVal.value
            let x2 = data.element._node.x2.baseVal.value
            let nx2 = (x2 - x1) * data.series.xModifier
            data.element._node.x2.baseVal.value += nx2
            data.x2 += nx2
          }
          let animationDefinitionVert = {
            x2: {
              begin: 0,
              dur: this.durations,
              from: data.x1,
              to: data.x2,
              easing: 'ease'
            },
            opacity: {
              begin: 0,
              dur: this.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          }
          let animationDefinitionHor = {
            y2: {
              begin: 0,
              dur: this.durations,
              from: data.y1,
              to: data.y2,
              easing: 'ease'
            },
            opacity: {
              begin: 0,
              dur: this.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          }
          let labelData = data.series.labelData
          data.element.animate((isVertical ? animationDefinitionVert : animationDefinitionHor), false)
          if (!data.series.color) {
            data.element.attr({
              class: `${
                        data.element._node.className.baseVal
                                          .trim()
                                          .replace(/color-(\d+)?/, '')
                      } color-${this.colorStep(this.seq2, label, 1)
                      } color-${label}`,
              style: `stroke-width: ${barWidth}; pointer-events:all; cursor: ${this.chartComponent.drillDown && !this.showBack ? 'pointer' : 'default'}`,
              dataLabel: `${this.chartData.labels[data.index]}`
            })
          } else {
            data.element.attr({
              class: `${
                        data.element._node.className.baseVal
                                          .trim()
                                          .replace(/color-(\d+)?/, '')
                      } color-${label}`,
              style: `stroke-width: ${(labelData && labelData[data.index] === 'No Budget' ? '2px' : barWidth)}; pointer-events:all; stroke:${barColor}; cursor: ${this.chartComponent.drillDown && !this.showBack ? 'pointer' : 'default'}`,
              dataLabel: `${this.chartData.labels[data.index]}`
            })
          }
          var ignoreLabel = data.series.ignoreLabel
          if (!ignoreLabel || labelData) {
            // labels on bars
            let barLabel
            let barLabelTextSpan
            let verticalOffset = isVertical ? 0 : 10
            let labelText = labelData ? labelData[data.index] : (ignoreLabel === false ? data.series.metadata.barLabels[data.index] : data.value.y)
            let negativeValue = labelText.toString().indexOf('-') === 0
            let redOn = negativeValue || labelText.toString().indexOf('!$red$!') === 0
            labelText = labelText.replace('!$red$!', '')
            if (negativeValue && !isVertical) verticalOffset = (verticalOffset + 5) * -1
            if (labelText && isVertical) labelText += ' ' + (labelText === 'No Budget' ? '' : this.$parent.$parent.currency)
            let barHorizontalCenter = isVertical ? data.element._node.ownerSVGElement.clientWidth - 50 : data.x1
            let barVerticalCenter = data.y2 - verticalOffset

            data.element.attr({ label: labelText }, 'ct:series')

            barLabel = new this.$Chartist.Svg('text')
            barLabelTextSpan = new this.$Chartist.Svg('tspan')
            barLabelTextSpan.text(labelText)
            barLabelTextSpan.attr({
              class: 'ct-interaction-on',
              dataLabel: `${this.chartData.labels[data.index]}`
            })
            barLabel.append(barLabelTextSpan)

            barLabel.attr({
              x: barHorizontalCenter - (labelData ? 20 : 0),
              y: barVerticalCenter,
              width: barWidth,
              dataLabel: `${this.chartData.labels[data.index]}`,
              class: 'ct-label ct-interaction-on',
              style: redOn ? 'fill: red' : '',
              'text-anchor': 'middle'
            })
            data.group.append(barLabel)

            if (this.chartComponent.components.dataLabel) {
              new Vue({
                render: h => h(this.chartComponent.components.dataLabel, {
                  props: {
                    value: labelText
                  }
                })
              }).$mount(barLabel._node.childNodes[0])
            }
          }
          this.updateChartVisuals(isVertical)
        }
      })
      // this.seq2 = 0
      this.seq2 = 0
    },

    startAnimationForPieChart(chart) {
      chart.on('draw', (data) => {
        if (data.type === 'slice') {
          let pathLength = data.element._node.getTotalLength()
          data.element.attr({ 'stroke-dasharray': pathLength + 'px ' + pathLength + 'px' })
          let animationDefinition = {
            'stroke-dashoffset': {
              id: 'anim' + data.index,
              dur: this.durations / 3,
              from: -pathLength + 'px',
              to:  '0px',
              fill: 'freeze'
            }
          }
          if (data.index !== 0) {
            animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end'
          }
          this.seq2++
          data.element.attr({ 'stroke-dashoffset': -pathLength + 'px' })
          data.element.animate(animationDefinition, false)
        }

        let label = this.chartData.labels[data.index].replace(/ /g, '')
        data.element.attr({
          class: `${
                    data.element._node.className.baseVal
                                      .trim()
                                      .replace(/color-(\d+)?/, '')
                  } color-${this.colorStep(this.seq2, label, 1)
                  } color-${label}`,
          style: `pointer-events:all; cursor: ${this.chartComponent.drillDown && !this.showBack ? 'pointer' : 'default'}`,
          dataLabel: `${this.chartData.labels[data.index]}`,
          dataValue: `${this.chartData.series[data.index]}`
        })
      })
      this.seq2 = 0
    },

    showTooltip(e) {
      if (!this.chartComponent.components.tooltip) return
      const value = e.target.getAttribute('dataLabel')
      const ctChart = this.$el.querySelector('.ct-chart')
      ctChart.addEventListener('mouseleave', this.resetTooltip)
      this.$el.querySelector('.card-chart').addEventListener('mouseleave', this.resetTooltip)
      if (value) {
        const { labels : lb } = this.chartData
        const index = lb.indexOf(value)
        const row = lb[index]
        if (this.selectedIndex === 0 || this.selectedIndex !== index) {
          this.populateTooltipData(row, index, e)
        }
        this.emitTooltipEvent(e)
        ctChart.addEventListener('mousemove', this.moveTooltip)
      } else {
        this.$el.querySelector('.card-chart').removeEventListener('mouseleave', this.resetTooltip)
        ctChart.removeEventListener('mousemove', this.moveTooltip)
        this.resetTooltip()
      }
    },

    moveTooltip(e) {
      var tt = document.getElementById('chart-Tooltip').firstElementChild
      if (tt && this.hasTooltipData) {
        tt.style.left = e.pageX + 15 + 'px'
        tt.style.top = e.pageY + 15 + 'px'
      }
    },

    populateTooltipData(row, index, e) {
      const { customSettings: cs } = this.chartComponent.chartOpts
      const { fullTooltipData : ft } = this
      if (ft) {
        this.tooltipData = {
          data: ft.metadata,
          helpText: ft.helpText
        }
        this.tooltipData.data.forEach((entry, i) => { entry.content = Array.isArray(ft.data[i]) ? ft.data[i][index] : ft.data[i] })
        this.hasTooltipData = true
        if (this.tooltipData.data[0].content === 'Other Hotel Chains') this.tooltipData.helpText = ''
        this.tooltipStyle = {
          top: `${window.scrollY + e.pageY + 15}px`,
          left: `${e.pageX + 15}px`,
          'margin-left': `-${e.target.style['stroke-width']}`,
          width: cs.tooltip.width,
          position: 'fixed'
        }
        this.selectedIndex = index
      } else return
    },

    resetTooltip () {
      if (this.hasTooltipData) {
        this.tooltipStyle = { null: true }
        this.tooltipData = []
        this.selectedIndex = null
        this.hasTooltipData = false
        this.emitTooltipEvent()
      }
    },

    emitTooltipEvent(e) {
      EventBus.$emit('showChartTooltip', {
        type: this.chartComponent.components.tooltip,
        style: this.tooltipStyle,
        tooltipData: this.tooltipData,
        currency: this.$parent.$parent.currency,
        hasData: this.hasTooltipData
      })
    },

    handleDate() {
      this.$parent.$parent.$refs.datepick.togglePopup()
      this.$nextTick(() => {
        this.$parent.$parent.$refs.datepick.$el.classList.toggle('picker-top')
      })
    },

    setDate1Month() {
      this.$parent.$parent.$refs.datepick.setPreset('Last1Month')
    },

    setDate3Months() {
      this.$parent.$parent.$refs.datepick.setPreset('Last3Months')
    },

    drillDown(e) {
      if (this.isDrilledDown) return
      let value
      let row
      let index
      this.loading = true
      if (((e.target.nodeName.toLowerCase() === 'line' || e.target.nodeName.toLowerCase() === 'path') && e.target.getAttribute('ct:value')) || e.target.classList.contains('ct-interaction-on')) {
        this.resetTooltip()
        value = e.target.getAttribute('dataLabel')
        let dataValue = e.target.getAttribute('dataValue') || (this.isIE ? (e.target.childElementCount === 3 ? e.target.childNodes[2].getAttribute('dataValue') : null) : (e.target.childElementCount === 3 ? e.target.children[2].getAttribute('dataValue') : null))
        if (value === 'Other Hotel Chains' || dataValue === '0') {
          this.loading = false
          return
        }
        row = this.rawData.filter(row => ~row.indexOf(value))[0]
        index = this.rawData.indexOf(row)
        this.showBack || drillDown.call(this)
      } else {
        if (typeof e === 'number') {
          index = e
          row = this.rawData[index]
          this.showBack || drillDown.call(this)
          this.resetTooltip()
        }
      }
      this.selectedIndex = index
      function drillDown() {
        this.executeDrilldown(value)
      }
    },

    executeDrilldown(value) {
      if (typeof this.chartComponent.drillDown === 'function') {
        this.tooltipStyle = { null: true }
        this.tooltipData = []
        this.isDrilledDown = true
        this.drilldownValue = value
        this.chartData = utils.copy(this.originalData)
        this.chartInfo = utils.copy(this.originalInfo)
        this.drillDownFilterValue = value
        this.drillDownFilterText = this.getDrilldownDisplayValue(value)
        this.showBack = true
        this.customSettings.hasDrillDown = false
        this.$parent.isDisabled = true
        this.resetTooltip()
        this.chartComponent.drillDown.call(this, this, value)
      }
    },

    getDrilldownDisplayValue(value) {
      if (value.length > 40) return value.slice(0, 25) + '...'
      else return value
    },

    goBack() {
      if (typeof this.chartComponent.drillDownReturn === 'function') {
        this.loading = true
        this.chartData = utils.copy(this.originalData)
        this.chartInfo = utils.copy(this.originalInfo)
        this.showBack = false
        this.selectedIndex = null
        this.isDrilledDown = false
        this.drilldownValue = null
        this.customSettings.hasDrillDown = true
        this.needsRefresh = true
        this.$parent.isDisabled = false
        this.chartComponent.drillDownReturn.call(this, this)
      }
    },

    handleResize() {
      this.seq = 0
      this.seq2 = 0
    },

    updateChartVisuals(isVertical) {
      const hTextLabels = document.querySelectorAll('.ct-label.ct-horizontal.ct-end:not([title])')
      const vTextLabels = document.querySelectorAll('.ct-label.ct-vertical.ct-start:not([title])')
      const hGridLines = document.querySelectorAll('.ct-grid.ct-vertical')
      this.updateGridLines(hGridLines)
      this.updateLabels(vTextLabels, false, true)
      this.updateLabels(hTextLabels, isVertical, false)
    },

    updateGridLines(elems) {
      Array.prototype.forEach.call(elems, (line) => {
        line.setAttribute('x1', 2)
      })
    },

    updateLabels(divs, hideAction, isVertical) {
      const maxLen = isVertical ? 35 : 34
      Array.prototype.forEach.call(divs, (span) => {
        if (hideAction === true) {
          span.setAttribute('style', 'display: none')
        } else {
          let content = span.textContent
          if (content.length >= maxLen) {
            span.textContent = content.slice(0, maxLen - 2) + '...'
            span.setAttribute('title', content)
            span.setAttribute('style', 'pointer-events:all')
          }
        }
      })
    },

    colorStep(point, label, base, offset) {
      let step = this.chartData.series[0] && this.chartData.series[0].length > 10 ? 0 : 1 || 0
      let colors = this.chartComponent.colors || {}
      let colIndex = colors[label] ? colors[label] : (point % 15 === base ? base : point % 15 + step) + (offset || 0)
      return colIndex
    }
  }
}
</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";

  .chart-header {
    position: relative;
    @include theme {
      border-bottom: 1px solid v(background-light);
    }
    margin: .0rem .3rem;
    padding-bottom: 5px;
    .section{
      display: inline-block;
      &.left{ 
        width: 40%; 
        .back-action a { width:200%;}
        }
      &.right{ float: right; }
      &.center{ width: 45%; }
    }
  }
  .dateText{
    font-size: $font-size-xsmall;
    font-weight: 300;
    font-style: italic;
    color: #a9a9a9;
    line-height: 1rem;
    pointer-events: all;
  }
  .dateSelector-v-divider{
      border-left: 1px solid #a9a9a9;
      width: 1px;
      margin: 0 8px;
  }
  .dateSelectorTX{
    &.active{ color: black; }
    font-size: 0.8rem;
    font-weight: 400;
    color: #a9a9a9;
    line-height: 1rem;
    padding: 2px 8px;
    background-color: #ffffff;
    pointer-events: all;
    cursor: pointer;
      &:hover {
        border-radius: 5px;
      background-color: $highlight-gray;
      @include theme {
      color: v(ink);
      }
    }
  }
  .chartHeaderText{
    font-weight: 800;
    font-size: 0.8rem;
    padding-right: 1.5rem;
    @include theme {
      color: v(ink);
    }
  }
  .back-action  {
      color: #cccccc;
      height: 1.3em;
      pointer-events: all;

  }
  .chart-back::before { 
      content: '\f053 ';
      padding-right: 0.2rem;
      font-size: 0.8rem;
      font-family: 'Font Awesome 5 Solid'
  }
  .chart-back{
      font-weight: 800;
      font-size: 0.8rem;
      cursor: pointer;
      line-height: 1.4em;
      font-family: 'Source Sans Pro';
      @include theme {
        color: v(ink)!important;
      }
      padding-right: 8px;
  }
  .empty {
    color: #9c9c9c;
    margin-top: 10px;
    font-size: 0.5rem;
    h3.text-center{
      margin:0;
    }
    i.fal{
        font-size: 3rem;
        height: 80px;
        width: 80px;
        padding-top:16px;
        padding-left:5px;
        background-color:#f2f2f2;
        border-radius: 50%;
        margin-bottom: 20px;
        display: inline-block;
    }
    p{
      line-height: 0.7rem;
    }
    p.bold{
      font-weight: 600
    }
    p.light{
      font-size: 0.8rem;
      font-weight: 250
    }
  }
  .card-chart-tall {
    height: 22rem;
    min-height: 50px;
    overflow-x: auto;
    overflow-y: hidden;
    width:100;
    &.noData {
       height: 200px!important;
       margin-top:0px;
    }
  }
  .card-chart  {
    position: relative;
    .events-on {
      pointer-events: all;
  }
  .ct-chart {
      &.hidden {
        display: hidden;
      }
      .ct-bar{
        pointer-events: all;
      }
      &.card-pie-chart {
        position:relative;
        display: inline-block;
        width: 50%
      }
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 95%;
      z-index: 1;
      .ct-grid.ct-vertical {
        stroke: #ececec;
      }
    }
  }
  .no-margin{
    margin:none;
  }
  .card-footer {
      margin-right: 10px;
      padding: 0px;
      margin: 0px 10px 0px 10px;
  }
  .events-off { 
    pointer-events: none; 
  }
  .legend-small {
      width: 75%;
      position: absolute;
      right: 0;
      .legend { 
      height: 3.2rem;
      width: 26rem;
      text-align: right;
      display: table-cell;
      vertical-align: middle;
      .swatch { 
        margin-right: 5px;
      }
      .swatch.line {
        margin-right: 5px;
        width: 12px;
        height: 3px;
      }
      .item {
        padding-right: 15px;
        display: inline-block;
      }
      .item.no-border{
        border-bottom: none;
        line-height: 2em;
        .key {
          @include theme {
            color: v(ink)!important;
          }
        }
      }
    }
  }
  .inChartLegend {
    width: 50%;
    overflow: hidden;
    display: inline-block;
    position: absolute;
    margin-left: -10px;
    height: 280px;
    .chart-back{
      max-width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .item{
      a.key{ 
        max-width: 55%;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: absolute;
        @include theme {
          color:v(ink)
        }
        }
      span.value{
        color: #333;
        }
      a.value{
        color: #333;
        padding-right:10px;
      }
    }
    
  }
  .inChartLegendHead{
    display:flex;
    padding-left: 5px;
      .left{ 
        width: 90%; }
  }
  .legend {
    font-size: $font-size-base-sm;
    .item {
      line-height: 2.2em;
      padding: 0 5px;
      transition: .3s ease-in-out;
      .swatch[class]:not(.line) {
        width: 12px;
        height: 12px;
      }
      .key {
        margin: 0;
      }
      .value {
        float: right;
      }
      &.selected {
        @include theme {
        background: lighten(v(secondary-04), 7%);
        }
      }
    }
    .swatch {
      display: inline-block;
      width: 8px;
      height: 8px;
      margin: 2px;
      margin-right: 10px;
      vertical-align: middle;
    }

    dt {
      font-weight: $font-weight-default;
    }
  }
</style>



// WEBPACK FOOTER //
// src/core/components/mdChartWidget/index.vue